export const REPRODUCTIVE_ROUTES = {
  padMan             : 'pad/hombre',
  padWoman           : 'pad/mujer',
  fonasa             : 'pad/fonasa',
  historyPatient     : 'historial/paciente',
  insemination       : 'inseminacion-intrauterina',
  historyProfessional: 'historial/profesional',
  reproductive       : 'formulario/ciclo-de-actividad-sexual-dirigida',
};
